import * as React from 'react';
import ReactDatePicker from 'react-datepicker';

import { DateFormats, getFullDateLocalTimeZone, shouldShowInbuilt } from './helpers';

export { DateFormats };

interface IDatePickerProps {
	name?: string;
	label?: string;
	minDate?: string;
	maxDate?: string;
	value?: Date;
	isValid?: boolean;
	media?: any;
	onChange: (r: any) => void;
	format?: DateFormats;
}

interface IDatePickerState {
	showInbuilt: boolean;
	media?: any;
}

export class DatePicker extends React.Component<IDatePickerProps, IDatePickerState> {

	constructor(props: IDatePickerProps) {
		super(props);
		this.state = { showInbuilt: shouldShowInbuilt(props.format) };
		this.setInbuilt = this.setInbuilt.bind(this);
	}

	public componentWillMount() {
		// shouldShowInbuilt();
		const media = window.matchMedia('(min-width: 800px)');
		media.addListener(this.setInbuilt);
		this.setState({ media });
	}

	public componentWillUnmount() {
		this.state.media.removeListener(this.setInbuilt);
	}

	public setInbuilt() {
		const { format } = this.props;
		this.setState({showInbuilt: shouldShowInbuilt(format)});
	}

	public render() {
		const { name, label, minDate, maxDate, value, isValid, onChange, format } = (this.props || {} as IDatePickerProps);
		const inputClassList = ['form__input', 'form__input--date-picker'];

		if (isValid === false) {
			inputClassList.push('form__input--error');
		}
		return <div className="date-picker">
			{label && <p className="date-picker__label">
				{label}
			</p>}
			{this.state.showInbuilt ? <input
				type="date"
				className={inputClassList.join(' ')}
				min={minDate}
				max={maxDate}
				value={value instanceof Date ? getFullDateLocalTimeZone(value, DateFormats.YearMonthDay) : ''}
				onChange={(e: any) => onChange(e.target ? e.target.value : '')}
			/>
			:
			<ReactDatePicker className={inputClassList.join(' ')}
				name={name || 'datePicker'}
				selected={value instanceof Date ? value : null}
				value={value instanceof Date ? getFullDateLocalTimeZone(value, format || DateFormats.DayMonthYear) : ''}
				placeholderText={'dd/mm/yyyy'}
				onChange={(date: Date) => onChange(getFullDateLocalTimeZone(date, DateFormats.YearMonthDay))} />}
		</div>;
	}

}
